import { DeskUser } from 'client/api/backend/schemas';
import { registerToolkitObjectType } from 'client/components/toolkit/objects/registerToolkitObjectType';

export const UserToolkitObject = registerToolkitObjectType<DeskUser>('user');
